import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">平台优势</h2>
          <p className="text-sm text-foreground-500 mt-3">为什么选择桃花视频</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {featuresData.map((item, i) => (
            <div key={i} className="group p-6 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-500/20 transition-all text-center">
              <div className="w-14 h-14 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-100 mt-4">{item.title}</h3>
              <p className="text-xs text-foreground-500 mt-2 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}